export default function PHP_MySQLDelete() {
  return (
    <div>
      <h1>PHP_MySQLDelete</h1>
    </div>
  );
}
